// useRoomInfo.js
import { useState, useEffect } from "react";
import { roomsInfo } from "../text";
import useSingleRoomTranslation from "./useSingleRoomTranslation";
import { useTranslation } from "react-i18next";

const useRoomInfo = (roomNumber: any) => {
  const [roomInfo, setRoomInfo] = useState({
    title: "",
    description: "",
    name: "",
    persone: 0,
  });

  const rooms = useSingleRoomTranslation();
  const { i18n } = useTranslation(); // Aggiungi questa riga

  useEffect(() => {
    const room = rooms.find((room) => room.roomNumber === roomNumber);
    if (room) {
      setRoomInfo({
        title: room.title,
        description: room.description,
        name: room.name,
        persone: room.persone,
      });
    } else {
      setRoomInfo({
        title: "Room not found",
        description: "No description available",
        name: "Room not found",
        persone: 0,
      });
    }
  }, [roomNumber, i18n.language]);

  return roomInfo;
};

export default useRoomInfo;
